import React from 'react';

import MobileMenuLinks from './mobile-menu-links';
import SidebarBanner from './sidebar-banner/sidebar-banner';

const MobileSidebarMenu = () => {
  return (
    <>
      <SidebarBanner />
      <MobileMenuLinks />
    </>
  );
};

export default MobileSidebarMenu;
